import React from "react";
import { certifications } from "@/lib/data";
import { ShieldCheck } from "lucide-react";

export default function Certifications() {
    const items = [...certifications, ...certifications, ...certifications];
    return (
        <section
            data-testid="certifications-marquee"
            className="relative py-16 md:py-20 border-t border-term-green/15 bg-bg-surface/30"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-10 mb-8 flex items-end justify-between gap-4 border-b border-term-green/20 pb-4">
                <div className="flex items-baseline gap-4">
                    <span className="font-mono text-xs text-ink-tertiary tabular-nums">
                        05
                    </span>
                    <h3 className="font-mono text-[11px] uppercase tracking-[0.32em] text-term-green">
                        // certifications
                    </h3>
                </div>
                <span className="hidden md:inline-block font-mono text-[11px] text-ink-tertiary uppercase tracking-[0.22em]">
                    <span className="text-term-green">$</span> cat ./certs.log
                </span>
            </div>

            <div className="marquee-wrap">
                <div className="animate-marquee flex gap-4 w-max">
                    {items.map((c, i) => (
                        <div
                            key={i}
                            data-testid={`cert-chip-${i}`}
                            className="shrink-0 inline-flex items-center gap-3 border border-term-green/25 bg-black/60 px-5 py-3 font-mono"
                        >
                            <ShieldCheck className="w-4 h-4 text-term-green" />
                            <div className="leading-tight">
                                <div className="text-sm text-ink-primary">
                                    {c.name}
                                </div>
                                <div className="text-[10.5px] uppercase tracking-[0.22em] text-ink-tertiary mt-0.5">
                                    {c.issuer}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
